var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pricing-import',{staticClass:"promotional-pricing-import",attrs:{"formName":"promotional-pricing-import","moduleSlug":"promotional-pricing-import","controllerName":"PromotionalPricingImport.vue","moduleName":"Promotional Pricing Import","priceTypeId":"2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }